<template>
  <div class="switcher !static max-lg:!border-b-0">
    <button
      v-click-outside="closeDropdown"
      class="dropdown-toggle capitalize"
      @click="toggleDropdown"
    >
      {{ t("header.more") }}
      <icon-chevron-black class="mx-2" />
    </button>
    <div
      v-if="isOpen"
      class="dropdown-menu lg:!right-[unset] lg:!left-[unset] lg:ltr:-ml-10 lg:rtl:-mr-10 border-b-0 mt-3"
    >
      <li
        v-for="link in links"
        :key="link.title"
        class="menu-item max-lg:!border-b-0 lg:!text-center lg:!mx-0 lg:!w-auto"
      >
        <NuxtLink
          :to="link.itsOuterLink ? link.target : localePath(link.target)"
          :target="link.itsOuterLink ? '_blank' : '_self'" 
        >
          {{ t(link?.title) }}
        </NuxtLink>
      </li>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import type { PropType } from "vue";

const { t } = useI18n();
const localePath = useLocalePath();

defineProps({
  links: { type: Array as PropType<any[]>, required: true },
  isCentered: { type: Boolean, default: false },
});

const isOpen = ref(false);

const toggleDropdown = () => {
  isOpen.value = !isOpen.value;
};
const closeDropdown = () => {
  isOpen.value = false
};
</script>
